import { IRoleEnum } from "@interfaces";
import { createRoute } from "@routes/utils";

import { warehouseCirculationReportRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";

const permission = [IRoleEnum.STORE];

const warehouseCirculationReportRouteMetadata: IRouteMetadataObj<
  typeof warehouseCirculationReportRoutesObj
> = {
  list: {
    title: "warehouseManagement.index.title",
    description: "empty",
    lazy: () =>
      import("@pages/warehouseManagement/warehouseCirculationReport/table/page"),
    mode: "index",
    type: "main",
    icon: "Building2Line",
    breadcrumbs: [],
    permission,
  },
};

export const warehouseCirculationReportRoutes = createRoute<
  typeof warehouseCirculationReportRoutesObj
>(warehouseCirculationReportRoutesObj, warehouseCirculationReportRouteMetadata);
